import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative px-5 md:px-10 pb-10 pt-20 bg-ink text-white overflow-hidden"
    >
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-brand/20 blur-[140px]" />

      <div className="relative max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_premium-coinsflu/artifacts/31ksmxsk_coinsflu.jpg"
                alt="CoinsFlu"
                className="w-10 h-10 rounded-xl"
              />
              <span className="font-pixel text-lg tracking-[0.04em]">
                CoinsFlu
              </span>
            </div>
            <p className="mt-5 text-white/60 max-w-sm text-[15px] leading-relaxed">
              Turn waiting into earning. An offerwall-based rewards app by
              King's Wake Digital Private Limited.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-pixel text-[10px] tracking-[0.25em] uppercase text-white/40">
              Product
            </div>
            <ul className="mt-4 space-y-2.5 text-[15px]">
              <li>
                <a
                  href="#about"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-about"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#download"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-download"
                >
                  Download
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-contact"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-pixel text-[10px] tracking-[0.25em] uppercase text-white/40">
              Legal
            </div>
            <ul className="mt-4 space-y-2.5 text-[15px]">
              <li>
                <Link
                  to="/privacy"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-privacy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-terms"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/delete-account"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-delete-account"
                >
                  Delete Account
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-pixel text-[10px] tracking-[0.25em] uppercase text-white/40">
              Company
            </div>
            <ul className="mt-4 space-y-2.5 text-[15px]">
              <li>
                <a
                  href="https://kingswake.co.in/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-kingswake"
                >
                  King's Wake
                </a>
              </li>
              <li>
                <a
                  href="mailto:team@kingswake.co.in"
                  className="text-white/80 hover:text-brand transition-colors"
                  data-testid="footer-link-email"
                >
                  team@kingswake.co.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-white/40 text-sm">
            © {year} King's Wake Digital Private Limited. All rights reserved.
          </div>
          <div className="font-pixel text-[10px] tracking-[0.3em] uppercase text-brand pixel-caret">
            Made in Punjab, India
          </div>
        </div>
      </div>
    </footer>
  );
}
